import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableTbodyFn = /* @__PURE__ */ createRecipe('table-tbody', {}, [])

const tableTbodyVariantMap = {}

const tableTbodyVariantKeys = Object.keys(tableTbodyVariantMap)

export const tableTbody = /* @__PURE__ */ Object.assign(memo(tableTbodyFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableTbody',
  __getCompoundVariantCss__: tableTbodyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableTbodyVariantKeys,
  variantMap: tableTbodyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableTbodyVariantKeys)
  },
  getVariantProps: tableTbodyFn.getVariantProps,
})